/*
 * Estados de una vista: cargando, vacío y error.
 * Toda pantalla debe resolver los tres. Una pantalla en blanco deja al usuario
 * sin saber si la aplicación falló o si simplemente no hay datos.
 */
.contenedor {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;
  padding: 40px 20px;
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--card);
}

.icono {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--estado-color) 12.5%, transparent);
  color: var(--estado-color);
  margin-bottom: 2px;
}

.titulo {
  font-family: var(--font-heading);
  font-size: var(--text-title);
  font-weight: 700;
  color: var(--text-1);
}

.descripcion {
  font-size: var(--text-body);
  color: var(--text-2);
  max-width: 46ch;
  line-height: 1.5;
}

.acciones {
  display: flex;
  gap: 8px;
  margin-top: 6px;
  flex-wrap: wrap;
  justify-content: center;
}

/* --- Esqueletos de carga --- */
.esqueleto {
  background: linear-gradient(
    90deg,
    color-mix(in srgb, var(--text-2) 8%, transparent) 25%,
    color-mix(in srgb, var(--text-2) 16%, transparent) 37%,
    color-mix(in srgb, var(--text-2) 8%, transparent) 63%
  );
  background-size: 400% 100%;
  animation: brillo 1.4s ease infinite;
  border-radius: 6px;
}

@keyframes brillo {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

.listaEsqueletos {
  display: flex;
  flex-direction: column;
  gap: var(--gap-list);
}

.tarjetaEsqueleto {
  height: 62px;
  border-radius: var(--radius-card);
}

/* --- Indicador de carga en línea --- */
.girador {
  width: 28px;
  height: 28px;
  border: 3px solid color-mix(in srgb, var(--text-2) 25%, transparent);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: girar 800ms linear infinite;
}

@keyframes girar {
  to {
    transform: rotate(360deg);
  }
}
